module.exports = __webpack_public_path__ + "img/78.e62bb571.jpg";